import { Injectable } from '@angular/core';
import { MenuItemCategory } from '@hospitality-bot/entity';
import { ApiService } from '@hospitality-bot/shared/utils';

@Injectable({
  providedIn: 'root',
})
export class CategoryService extends ApiService {
  createCategory(entityId: string, data: MenuItemCategory) {
    return this.post(`/api/v1/entity/${entityId}/categories`, data);
  }
}
